import styled from 'styled-components'

import AutoTable from 'components/AutoTable'
import Button from 'components/Button/Button'
import { themeGet } from 'styled-system'

export const UploadButton = styled(Button)`
  margin: 5px;
  background-color: #002855;
`
export const Instructions = styled.span`
  display: flex;
  font-family: Molde-bold;
  padding: 0.6rem 0;
`
export const ExampleImage = styled.img`
  display: flex;
  width: 100%;
`
export const UploadSection = styled.div`
  display: flex;
  padding: 1rem 0 0.5rem;

  & > div {
    display: flex;
    flex: 1;
  }

  & > div + div {
    justify-content: flex-end;
    align-items: baseline;
  }
`

export const Required = styled.span`
  color: red;
  margin-left: 0.5rem;
`

export const ErrorMessage = styled.div`
  margin-top: 0.25rem;
  color: red;
`

export const ResultsSection = styled.div`
  margin: 1rem 0rem;
  max-height: 500px;
  overflow-y: auto;

  & a {
    color: ${themeGet('colors.blue')};
  }

  & a:hover {
    color: ${themeGet('colors.darkBlue')};
  }
`

export const StyledAutoTable = styled(AutoTable)`
  margin-top: 1rem;
`

export const TemplateLinkWrapper = styled.div`
  a {
    color: ${themeGet('colors.blue')};
  }
`
